export const HISTORICAL_INFO = "historicalInfo";
export const EXISTING_BENEFITS = "existingBenefits";
export const PROJECTION_PERIOD = "projectionPeriod";
export const ESTIMATION_GAPS = 'estimationGaps';
export const COVERED_POPULATION = 'coveredPopulation';
export const FINANCIAL_PROJECTION = 'financialProjection';
export const GRAPHICS = 'allGraph';
export const RESULTS = 'results';
export const INDICATORS = 'indicators';